import { ModalFuncProps } from 'antd';
import React from 'react';
import { ProjectId } from 'api/models';
import { ProjectAPI } from 'api/project';
import { confirm } from 'components/atoms/modal';
import { toastService } from 'components/molecules/toast';
import { InvitedMembers } from 'data/members/slice';
import { useTranslation } from 'hooks/use-translation';

interface InviteRequestConfig {
  onSuccess?: (res: InvitedMembers[]) => void;
  onError?: (error: unknown) => void;
}

export const useInviteUserToProjectConfirmation = () => {
  const title = useTranslation('invitation.team_member.confirm.title');
  const content = useTranslation('invitation.team_member.confirm.content');
  const okText = useTranslation('continue');
  const cancelText = useTranslation('cancel');

  const successTitle = useTranslation('invitation.team_member.success.title');
  const successMessage = useTranslation(
    'invitation.team_member.success.content',
  );

  const errorTitle = useTranslation('invitation.team_member.error.title');
  const errorMessage = useTranslation('invitation.team_member.error.content');

  return (
    [, projectId]: ProjectId,
    members: InvitedMembers[],
    config: InviteRequestConfig = {},
    confirmProps?: ModalFuncProps,
  ) => {
    const { onSuccess, onError } = config;

    return confirm({
      title,
      content: <>{content}</>,
      okText,
      cancelText,
      ...confirmProps,
      onOk: () =>
        ProjectAPI.addMembers(projectId, members)
          .then((res) => {
            if (onSuccess) {
              onSuccess(res);
            }
            toastService({
              toastContainer: {},
              title: successTitle,
              message: successMessage,
            }).success();
          })
          .catch((err) => {
            if (onError) {
              onError(err);
            }
            toastService({
              toastContainer: {},
              title: errorTitle,
              message: errorMessage,
            }).error();
          }),
    });
  };
};
